<template>
  <div class="wrapper">
  <AppLogo variant="prelogin"/>
  <div class="mb-25">
    <RequestSupport/>
  </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AppLogo from "../../components/Widgets/AppLogo.vue";
import RequestSupport from "@/components/Authentication/RequestSupport/RequestSupport.vue";

export default defineComponent({
  name: "RequestSupportPage",
  components: {
    AppLogo,
    RequestSupport,
  },
});
</script>